import React from 'react'

import { List, ListItem } from '~lib/ui-kit/List'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface IntegrationCasePreviewProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  title: string
  description: string
  aspects: string[]
}

function IntegrationCasePreview({ icon, title, description, aspects, ...props }: IntegrationCasePreviewProps) {
  return (
    <Flex key={title} direction="column" {...props}>
      <Flex align="center" justify="start" gap="1" className="mb-1">
        <Flex align="center" justify="center">
          {icon}
        </Flex>

        <Text as="h3" textType="heading-sm">
          {title}
        </Text>
      </Flex>

      <Text textType="body-md" variant="secondary" className="mb-2">
        {description}
      </Text>

      <List type="disc" variant="secondary" className="pl-3">
        {aspects.map((aspect) => {
          return <ListItem key={aspect}>{aspect}</ListItem>
        })}
      </List>
    </Flex>
  )
}

export default React.memo(IntegrationCasePreview)
